var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"intro-fade"}},[_c('div',{staticClass:"intro"},[_c('h1',[_c('span',{staticClass:"mobile-headline"},[_vm._v("ARCHIVES DU FUTUR"),_c('br'),_vm._v("Silvie & Chéerif Defraoui")]),_vm._v("Catalogue raisonné ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }